import {
  ACCOUNT_CHANGE_PASSWORD,
  USERS_ENDPOINT,
} from "../Constants/Endpoints";
import { apiCallJson } from "../Helpers";

export async function deleteUserCall(userId) {
  return await apiCallJson(USERS_ENDPOINT + "/" + userId, "DELETE");
}

export async function changePasswordRequest(body) {
  return await apiCallJson(ACCOUNT_CHANGE_PASSWORD, "PUT", body);
}
